import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "./ModalDetalle.css";

const OPCIONES_PAGO = {
  unico: "Unico",
  semanal: "Semanal",
  quincenal: "Quincenal",
  mensual: "Mensual",
  bimestral: "Bimestral",
  trimestral: "Trimestral",
  semestral: "Semestral",
  anual: "Anual",
};

const formatMoneda = (valor) =>
  (parseFloat(valor) || 0).toLocaleString("en-US", {style: "currency", currency: "USD"});

/** "2024-04-29" -> "29/04/2024". */
const formatFecha = (fecha) => {
  if (!fecha) return "—";
  const [anio, mes, dia] = String(fecha).slice(0, 10).split("-");
  if (!anio || !mes || !dia) return "—";
  return `${dia}/${mes}/${anio}`;
};

const Dato = ({label, valor}) => (
  <div className="detalle-campo">
    <label>{label}</label>
    <div>{valor ?? "—"}</div>
  </div>
);

/**
 * Detalle de un concepto ya guardado -- después de agregarlo sólo se veían
 * cuenta, nombre y montos en la tabla; aquí se ve todo lo demás que se
 * capturó (proveedor, variable, calendario de pagos).
 */
export default function ModalVerConcepto({abierto, toggle, concepto}) {
  if (!concepto) return null;

  return (
    <Modal isOpen={abierto} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Detalle del concepto</ModalHeader>
      <ModalBody>
        <div className="detalle-form" style={{background: "transparent", padding: 0}}>
          <Dato label="Cuenta presupuestal" valor={concepto.cuenta_presupuental} />
          <Dato label="Concepto" valor={concepto.Nombre ?? concepto.nombre} />
          <Dato label="Proveedor" valor={concepto.proveedor_nombre?.trim() || null} />
          <Dato label="Variable" valor={concepto.variable_nombre} />
        </div>

        <div className="detalle-form" style={{background: "transparent", padding: 0}}>
          <Dato label="Cantidad" valor={concepto.Cantidad ?? concepto.cantidad_veces_pagos} />
          <Dato label="Unidad" valor={concepto.Unidad ?? concepto.unidad} />
          <Dato label="X" valor={concepto.X ?? concepto.x_cuantas_veces} />
          <Dato label="Costo" valor={formatMoneda(concepto.costo_unitario)} />
        </div>

        <div className="detalle-form" style={{background: "transparent", padding: 0}}>
          <Dato label="Fecha primer pago" valor={formatFecha(concepto.fecha_inical_pagos)} />
          <Dato label="Opcion de pagos" valor={OPCIONES_PAGO[concepto.opcion_pagos] ?? "—"} />
          <Dato label="Cuantos pagos" valor={concepto.cuantos_pagos || "—"} />
          <Dato label="Estatus" valor={concepto.status_hijo} />
        </div>

        <div className="detalle-resumen">
          <div>
            <span className="detalle-resumen-etiqueta">Subtotal</span>
            <span className="detalle-resumen-valor">{formatMoneda(concepto.subtotal)}</span>
          </div>
          <div>
            <span className="detalle-resumen-etiqueta">IVA</span>
            <span className="detalle-resumen-valor">
              {concepto.con_iva ? formatMoneda(concepto.iva) : "No aplica"}
            </span>
          </div>
          <div>
            <span className="detalle-resumen-etiqueta">Total</span>
            <span className="detalle-resumen-valor es-cuadrado">{formatMoneda(concepto.total)}</span>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
